import React from 'react';
import PropTypes from 'prop-types';

import * as dispatchStyles from '../../../styles/widgets/dispatch.module.scss';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import {useTranslation} from 'react-i18next';
import {altNN} from '../../../utils/parsing';
import IconContainer from '../IconContainer';
import PolyLink from '../PolyLink';
import clsx from 'clsx';

const Dispatch = ({elem, column, row}) => {
  const {title, link, link_text, image, content} = elem;
  const {t} = useTranslation();
  const nbrLineMid = Math.floor(row / 2);

  return (
    <PolyLink
      ariaLabel={title}
      className={dispatchStyles.root}
      dataCy={'dispatch-link'}
      url={link}
    >
      {image?.imageFile &&
      <div
        className={clsx(dispatchStyles.containerImg,
          {
            [dispatchStyles.containerOneColumn]: column === 1,
            [dispatchStyles.imageOneColumnMultiRow]: (column === 1 && row > 1)
          }
        )}
        style={{
          gridColumn: `1 / ${Math.floor(column / 2) + 1}`,
          paddingBottom: `calc((100% / ${column}) * (${nbrLineMid}))`,
          gridRow: column === 1 ? '1/2' : '1 / -1',
        }}
      >
        <GatsbyImage
          alt={altNN(title)}
          className={dispatchStyles.image}
          image={getImage(image.imageFile)}
        />
      </div>
      }
      <div
        className={clsx({[dispatchStyles.containerOneColumn]: column === 1})}
        style={{
          gridColumn: `${(row === 1 && column === 1) ? 1 : Math.ceil(column / 2) + 1} / -1`,
          paddingBottom: `calc((100% / ${column}) * (${row}))`,
          gridRow: '2 / -1',
        }}
      />
      <div
        className={clsx(dispatchStyles.container, {[dispatchStyles.containerOneColumn]: column === 1})}
        style={{
          gridColumn: `${(row === 1 && column === 1) ? 1 : Math.ceil(column / 2) + 1} / -1`,
          gridRow: '2 / -1',
        }}
      >
        <p className={dispatchStyles.title}>
          {title}
        </p>
        <p className={dispatchStyles.content}>
          {content}
        </p>
        <div className={dispatchStyles.containerMore}>
          <p className={dispatchStyles.more}>
            {link_text || t('internal.page.more')}
          </p>
          <div className={dispatchStyles.arrowHover}>
            <IconContainer
              classname={dispatchStyles.icon}
              color="BLACK"
              icon="ARROW_RIGHT_NORMAL"
              size={20}
              tabIndex={-1}
            />
          </div>
        </div>
      </div>
    </PolyLink>
  );
};

Dispatch.propTypes = {
  column: PropTypes.number,
  elem: PropTypes.shape({
    content: PropTypes.string.isRequired,
    image: PropTypes.object,
    link: PropTypes.string.isRequired,
    link_text: PropTypes.string,
    title: PropTypes.string.isRequired,
  }),
  row: PropTypes.number
};

export default Dispatch;